export default [
    {
        path: '/',
        name: 'home',
        meta: {hideHeader: true,search: {name:'project-list'}},
        component: () => import( /* webpackChunkName: "app-index" */ "@/views/AppIndexPage"),
    },
    {
        path: '/projects/:id/pdf',
        name: 'project-pdf',
        meta: {
            projectHeader: true
        },
        component: () => import(/* webpackChunkName: "canvas-editor" */ '@/views/project/ProjectPDFSetupPage')
    },
    {
        path: '/projects/:id/upload',
        name: 'project-upload',
        meta: {search: false},
        component: () => import(/* webpackChunkName: "project-upload" */ '@/views/project/ProjectUploadAssetPage')
    },
    {
        path: '/projects/:id/drone',
        name: 'project-drone',
        meta: {search: false, projectHeader: true},
        component: () => import(/* webpackChunkName: "project-drone" */ '@/views/project/ProjectDroneSetupPage')
    },
    {
        path: '/projects/new/',
        name: 'project-new',
        meta: {search: {name: 'project-list'}},
        component: () => import(/* webpackChunkName: "project-new" */ '@/views/project/ProjectNewPage.vue')
    },  
    {
        path: '/projects/:id/edit',
        name: 'project-edit',
        meta: {search: {name: 'project-list'}},
        component: () => import(/* webpackChunkName: "project-new" */ '@/views/project/ProjectEditPage.vue')
    },
    {
        path: '/projects/:id/report',
        name: 'project-report',
        meta: {hideHeader: true, isPublicAuthenticatedPage: true},
        component: () => import(/* webpackChunkName: "project-new" */ '@/views/project/ProjectReportPage.vue')
    },
    {
        path: '/projects',
        name: 'project-list',
        meta: {hideHeader: true},
        component: () => import(/* webpackChunkName: "project-list" */ '@/views/project/ProjectIndexPage')
    },
    {
        path: '/clients',
        name: 'client-list',
        component: () => import(/* webpackChunkName: "client-list" */ '@/views/client/ClientIndexPage')
    },
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/settings/SettingsIndex'),
        children: [
            {
                path: 'equipments',
                name: 'equipment-settings',
                component: () => import(/* webpackChunkName: "unauthenticated" */ '@/views/settings/equipments/EquipmentIndexPage')
            },
            {
                path: 'equipments/:id/edit',
                name: 'edit-equipment-settings',
                component: () => import(/* webpackChunkName: "unauthenticated" */ '@/views/settings/equipments/EquipmentForm')
            },
            {
                path: 'agencies',
                name: 'agency-settings',
                component: () => import(/* webpackChunkName: "unauthenticated" */ '@/views/settings/agencies/AgencyIndex')
            },
            {
                path: 'agencies/:id/edit',
                name: 'edit-agency-settings',
                component: () => import(/* webpackChunkName: "unauthenticated" */ '@/views/settings/agencies/AgencyForm')
            },
            {
                path: 'divalto_codes',
                name: 'index-divalto-codes-settings',
                component: () => import(/* webpackChunkName: "unauthenticated" */ '@/views/settings/divaltoCodes/Index')
            },
            {
                path: 'grouping_rules',
                name: 'index-grouping-rules-settings',
                component: () => import('@/views/settings/groupingRules/Index')
            }

        ]
    },
    {
        path: '/unauthenticated',
        name: 'unauthenticated',
        component: () => import(/* webpackChunkName: "unauthenticated" */ '@/views/Unauthenticated')
    },
    {
        path: "*",
        redirect: "/"
    }
]